import { type Type, Directive, output, forwardRef, type OutputEmitterRef } from '@angular/core';
import { DROPDOWN_ITEM_CLICKABLE, type DropdownItemClickHandler } from './dropdown.domain';
import type { SelectableItem } from '../../domain/selectable.domain';

@Directive({
  selector: '[tdWbDropdownItemClick]',
  providers: [{
    provide: DROPDOWN_ITEM_CLICKABLE,
    useExisting: forwardRef((): Type<DropdownItemClickDirective<unknown>> => DropdownItemClickDirective)
  }]
})
export class DropdownItemClickDirective<T> implements DropdownItemClickHandler<T> {
  readonly customClick: OutputEmitterRef<SelectableItem<T>> = output<SelectableItem<T>>();

  onClick(item: SelectableItem<T>): void {
    this.customClick.emit(item);
  }
}
